import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import {
    FormsIntelDefaultFormFieldsMappingDto,
    FormsIntelFormConfigurationDto,
    FormsIntelFormConfigurationCreateParamsDto,
    FormsIntelFormConfigurationUpdateDto,
    FormsIntelMappedFieldsDto,
    FormsIntelFormConfigurationCreateResponseDto, FormsIntelFormConfigurationTypeDto,
} from '../../dto';
import { BaseApiService } from './base-api.service';
import { UserService } from '../../../core/services/user.service';

@Injectable({
    providedIn: 'root'
})
export class FormsintelApiService {
    formsListChanged$: Subject<boolean> = new Subject();
    private readonly url: string = 'service/formsintel/admin';

    constructor(
        private readonly userService: UserService,
        private readonly baseApiService: BaseApiService,
    ) {}

    getDefaultFormFieldMappings(): Observable<FormsIntelDefaultFormFieldsMappingDto> {
        return this.baseApiService.get<FormsIntelDefaultFormFieldsMappingDto>(`${this.url}/default/form/field/mappings`);
    }

    saveMappingForm(formId: number, dto: FormsIntelMappedFieldsDto): Observable<null> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.post<null>(`${this.url}/form/configuration/${accountId}/${formId}/mappings/save`, dto);
    }

    getFormsTypes(): Observable<FormsIntelFormConfigurationTypeDto[]> {
        return this.baseApiService.get<FormsIntelFormConfigurationTypeDto[]>(`${this.url}/form/configuration/types/get`);
    }

    createForm(dto: FormsIntelFormConfigurationCreateParamsDto): Observable<FormsIntelFormConfigurationCreateResponseDto> {
        return this.baseApiService.post<FormsIntelFormConfigurationCreateResponseDto>(`${this.url}/form/configuration/save`, dto);
    }

    updateForm(formId: number, form: FormsIntelFormConfigurationUpdateDto): Observable<FormsIntelFormConfigurationUpdateDto> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.post<FormsIntelFormConfigurationUpdateDto>(`${this.url}/form/configuration/${accountId}/${formId}/update`, form);
    }

    getMappingFields(formId: string|number): Observable<FormsIntelMappedFieldsDto> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.get<FormsIntelMappedFieldsDto>(`${this.url}/form/configuration/${accountId}/${formId}/mappings/get`);
    }

    deleteForm(formId: number): Observable<null> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.post<null>(`${this.url}/form/configuration/${accountId}/${formId}/form/delete`, {}, { showError: true });
    }

    getForms(): Observable<FormsIntelFormConfigurationDto[]> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.get<FormsIntelFormConfigurationDto[]>(`${this.url}/form/configuration/${accountId}/forms/get`);
    }

    getScript(formId: number): Observable<string> {
        const accountId: number = this.userService.getUserAccountId();
        return this.baseApiService.get(`${this.url}/form/script/get/${accountId}/${formId}`, null, {
            responseType: 'text',
        });
    }
}
